import DropdownMenu from '@atlaskit/dropdown-menu';
import React from 'react';
import { Trigger } from './components/trigger';
import { JoinSiteUserLoggedInView } from './join-site-user-logged-in-view';
import { messages } from './messages';

export type JoinSiteUserDropdownProps = {
  readonly userName?: string;
  readonly userEmail?: string;
  readonly avatarSrc?: string;
  readonly position?: string;
  readonly isLoggedIn: boolean;
  readonly onLogInClick: () => void;
  readonly onLogOutClick: () => void;
  readonly onManageLicenses: () => void;
  readonly onManageProfile: () => void;
  readonly onJoinYourTeam: () => void;
  readonly onSwitchAccountClick: () => void;
};

export function JoinSiteUserDropdown({
  userEmail = '',
  userName = '',
  avatarSrc = '',
  position = 'bottom right',
  isLoggedIn = false,
  onLogInClick,
  onLogOutClick,
  onManageLicenses,
  onManageProfile,
  onSwitchAccountClick
}: JoinSiteUserDropdownProps) {
  const trigger = (
    <Trigger
      avatarSrc={avatarSrc}
      isLoggedIn={isLoggedIn}
      userName={userName}
      onLogInClick={onLogInClick}
    />
  );
  return isLoggedIn ? (
    <DropdownMenu shouldFlip={false} trigger={trigger} position={position}>
      <JoinSiteUserLoggedInView
        avatarSrc={avatarSrc}
        userEmail={userEmail}
        userName={userName}
        onSwitchAccountClick={onSwitchAccountClick}
        onManageLicenses={onManageLicenses}
        onManageProfile={onManageProfile}
        onLogOutClick={onLogOutClick}
      />
    </DropdownMenu>
  ) : (
    <DropdownMenu shouldFlip={false} trigger={trigger} position={position} />
  );
}

JoinSiteUserDropdown.messages = messages;

export default JoinSiteUserDropdown;
